<template>
  <aside id="filters" class="top-48 h-full lg:w-74 hidden lg:block mt-28">
    <div v-if="!categories?.loaded" class="hidden xl:block">
      <div class="w-72 mt-8 px-2">
        <CategoryLoader />
      </div>
    </div>
    <ErrorMessage v-else-if="categories.error" :message="categories.error.message" />
    <div v-else class="max-h-full overflow-hidden">
      <div class="px-5 mb-12 h-full">
        <SidebarMenu :type="type" :items="items" :show-my="true" />
        <div v-if="type === CATEGORY_TYPE.ESHOP">
          <LocationFilter class="mb-5" />
          <FilterCategoryParameters />
          <WatchdogAddBtn />
        </div>
        <div v-else-if="type === CATEGORY_TYPE.INSPIRATION">
          <AddInspirationButton />
        </div>
        <div v-else-if="type === CATEGORY_TYPE.NEWS">
          <FilterContentParameters :type="CATEGORY_TYPE.NEWS" />
        </div>
      </div>
    </div>
  </aside>
</template>

<script setup>
import { CATEGORY_TYPE } from "@utils/constants";
import { useCategoryStore } from '@stores/category';
import SidebarMenu from "@components/ui/sidebar-menu";
import CategoryLoader from "@components/ui/loaders/category-loader";
import ErrorMessage from "@components/ui/error-message";
import LocationFilter from "@components/filter/location-filter";
import FilterContentParameters from "@components/filter/filter-content-parameters";
import FilterCategoryParameters from "@components/filter/filter-category-parameters";
import WatchdogAddBtn from "@components/watchdog/watchdog-add-btn";
import AddInspirationButton from "@components/content/add-inspiration-button";

const props = defineProps({
  type: {
    type: String,
    required: true
  }
});

const { $eventBus } = useNuxtApp();
const categories = useCategoryStore();
const items = ref(categories[props.type]);

watch(() => categories[props.type], values => {
  items.value = values;
});

const focusFilters = () => {
  window.scrollTo({ top: (document.getElementById('filters')?.offsetTop || 0) - 120, behavior: "smooth" });
};

onMounted(async () => {
  $eventBus.on('focus:filters', focusFilters);
});

onUnmounted(() => {
  $eventBus.off('focus:filters', focusFilters);
});


</script>
